// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oYtX","col":"styles_col__3o7DH"};